import React from 'react';
import Icon from '../../../components/AppIcon';

const LoginHeader = () => {
  return (
    <div className="text-center mb-12">
      {/* Logo and Brand */}
      <div className="flex items-center justify-center mb-6">
        <div className="w-12 h-12 bg-primary rounded-lg flex items-center justify-center mr-3">
          <Icon name="Package" size={28} color="white" />
        </div>
        <h1 className="text-3xl font-semibold text-foreground">InventoryTracker</h1>
      </div>

      {/* Tagline */}
      <p className="text-lg text-muted-foreground mb-8 max-w-2xl mx-auto">
        Streamline your inventory operations with our comprehensive management solution
      </p>

      {/* Key Features */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-3xl mx-auto">
        <div className="flex items-center justify-center space-x-3 p-4 bg-muted/50 rounded-lg">
          <Icon name="BarChart3" size={20} className="text-primary" />
          <span className="text-sm font-medium text-foreground">Real-time Analytics</span>
        </div>
        <div className="flex items-center justify-center space-x-3 p-4 bg-muted/50 rounded-lg">
          <Icon name="Scan" size={20} className="text-primary" />
          <span className="text-sm font-medium text-foreground">Barcode Scanning</span>
        </div>
        <div className="flex items-center justify-center space-x-3 p-4 bg-muted/50 rounded-lg">
          <Icon name="Bell" size={20} className="text-primary" />
          <span className="text-sm font-medium text-foreground">Smart Alerts</span>
        </div>
      </div>
    </div>
  );
};

export default LoginHeader;